// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__cP493","nav":"header_nav__YptrL","active":"header_active__csThp"};